import Splide from '@splidejs/splide';

/**
 * Merch Carousel Lazy Load
 */
(() => {
  document.querySelectorAll('.blogs-1').forEach((blogsSlider) => {
    const blogId = blogsSlider.getAttribute('data-blog');
    const splideList = blogsSlider.querySelector('.splide__list');
    if (!blogId || !splideList) return;

    $.ajax({
      type: 'post',
      url: '/ajax/merchandising',
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      data: { groupBlogFeaturedPosts_ids: [blogId] },
      success(response) {
        const featuredPosts = response.data.featuredposts;

        if (!featuredPosts) return;
        let htmlContent = '';
        const values = Object.values(featuredPosts);
        htmlContent = values
          .flatMap((item) => {
            if (Array.isArray(item)) {
              return item.map((post) => /* html */`
                  <li class="splide__slide">
                    <a class="blogs-1__blog-card" href="/${post.url}">
                      <div class="blogs-1__blog-card__image">
                        ${post.image ? `<img src="${post.image_path}${post.image}" alt="${post.alt_image || post.title}">` : ''}
                      </div>
                      <div class="blogs-1__blog-card__content">
                        <h2 class="blogs-1__blog-card__content__title">${post.name}</h2>
                        <div class="blogs-1__blog-card__content__excerpt">${post.excerpt}</div>
                        <button class="blogs-1__blog-card__content__link">Read More</button>
                      </div>
                    </a>
                  </li>
                `);
            }

            return '';
          })
          .join('');

        splideList.innerHTML = htmlContent;

        // Splide init
        new Splide(blogsSlider.querySelector('.splide'), {
          type: 'loop',
          perPage: 2,
          perMove: 1,
          gap: 30,
          pagination: true,
          arrows: false,
          autoplay: false,
          breakpoints: {
            1200: {
              perPage: 1,
            },
            991: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        }).mount();

        setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
      },
      error(err) {
        console.error('Error fetching merchandising data:', err);
      },
    });
  });
})();
